import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicCreerAnnonce = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Félicitations, vous êtes sur le point de créer un événement incroyable qui marquera les esprits&nbsp;! 
              Suivez les étapes détaillées, laissez-vous guider pas à pas, et donnez vie à votre compétition parfaite.
            </p>
            <p className="help-text">
              Pour débuter, rien de plus simple : depuis votre espace
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>admin,</a> 
              cliquez sur l'onglet <strong>Dashboard.</strong> puis cliquez simplement sur le bouton <strong>Créer une compétition.</strong>
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                C'est ici que vous renseignez les informations essentielles de votre compétition : son nom, 
                qui apparaîtra en titre des annonces, ainsi que les dates de début et de fin.
              </p>
              <p className="help-text">
                Pour l'adresse, entrez simplement le libellé (par exemple : 8 rue des Fleurs). Des suggestions 
                apparaîtront automatiquement, et il vous suffira de cliquer sur la bonne adresse pour qu'elle se 
                pré-remplisse instantanément.
              </p>
              <p className="help-text">
                Si votre compétition est <strong>exclusivement</strong> destinée aux adhérents de votre box de CrossFit, 
                cliquez sur le bouton : "Événement réservé aux membres de la box".
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                La section "Présentation" est essentielle pour donner un aperçu complet de votre compétition. 
                C'est ici que les athlètes peuvent découvrir tous les détails importants : description de 
                l'événement, dates clés, lieux, et autres informations pratiques. Vous pouvez également personnaliser 
                cette page en ajoutant une photo d'illustration et une bannière accrocheuse. Faites de cette section une vitrine 
                attrayante pour séduire vos participants potentiels !
              </p>
              <p className="help-text">
                Vous avez la possibilité de rendre votre annonce visible immédiatement pour les athlètes en la publiant, 
                ou de programmer une date spécifique à laquelle votre événement deviendra accessible.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                C'est ici que vous pouvez associer votre<a target='_blank' className="link" href={`#`}>compte de
                versement</a>Wodzone. Une fois l'association effectuée, 
                vous serez en mesure de recevoir vos paiements directement lors des inscriptions de vos athlètes.
              </p>
              <p className="help-text">      
                Vous pouvez également ajouter un ou plusieurs codes promo à votre compétition. Il vous suffit de définir 
                le nom du code et le pourcentage de réduction qui sera appliqué aux inscriptions.
              </p>
              <p className="help-text">      
                <strong className="mr-8">À noter :</strong> cette section peut être complétée ultérieurement si vous le souhaitez. Cependant, nous vous 
                recommandons vivement de configurer votre compte de versement dès que possible, car cela peut prendre 
                un certain temps et est essentiel pour recevoir vos paiements.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part">{anchorsParts[3].content}</p>
              <p className="help-text">
                Quel est le concept de votre compétition ? Préférez-vous un format individuel ou en équipe ? 
                Prévoyez-vous un événement en ligne ou dans une salle avec un public survolté ? 
                Découvrez toutes les options disponibles :
              </p>
              <ul>
                <li className="pl-8 mb-16"><p className="help-text"><strong>Indiv et Team : </strong></p></li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">En ligne ou sur place : </strong>
                    Votre compétition inclut-elle des qualifications en ligne, des floaters, ou se déroule-t-elle 
                    sur place en direct ? Il est possible de combiner les deux pour une expérience hybride.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Draft : </strong>
                    Le mode "Draft" permet aux organisateurs de composer les équipes à partir de la liste des athlètes inscrits, 
                    comme dans les célèbres drafts de la NBA. Les équipes peuvent être formées directement depuis le portail admin, 
                    dans l'onglet "Participants", juste après la sélection des athlètes.
                  </p>
                  <p className="help-text">
                    On peut même imaginer des capitaines choisissant tour à tour leurs coéquipiers pour une expérience encore 
                    plus immersive et stratégique.
                  </p>
                </li>
                <li className="pl-8 mb-16 mt-24">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Tri au ranking : </strong>
                    est un concept innovant qui permet de répartir les athlètes dans des catégories en fonction de 
                    leurs performances. Lors de l’inscription, tous les athlètes rejoignent une seule catégorie 
                    regroupant différents niveaux (par exemple : RX, Inter, Scaled).
                  </p>
                  <p className="help-text mb-8">
                    Ils réalisent ensuite les mêmes WODs, avec les mêmes exigences pour tous. À l’issue de ces épreuves, 
                    leur classement détermine leur attribution aux différentes catégories. Dans notre exemple, les meilleurs 
                    au classement intègrent la catégorie RX, suivis par Inter, puis Scaled. 
                  </p>
                  <p className="help-text mb-8">
                    Cela permet de répartir chaque athlète dans une catégorie qui reflète réellement son niveau de performance.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[4].ref}>
              <p className="help-title-part">{anchorsParts[4].content}</p>
              <p className="help-text">
                Ces tags sont essentiels pour décrire rapidement votre compétition. Ils permettent à vos athlètes 
                de filtrer leurs recherches et de trouver plus facilement votre événement. N'oubliez pas de les 
                renseigner, car ils jouent un rôle clé dans la visibilité de votre compétition.
              </p>
              <ul>
                <li className="pl-8 mb-8"><p className="help-text">Composition des athlètes</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Niveaux des catégories</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Récompenses / Prix</p></li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[5].ref}>
              <p className="help-title-part">{anchorsParts[5].content}</p>
              <p className="help-text">
                C'est ici que vous configurez la gestion de la billetterie, non pas pour le montant des inscriptions, 
                mais pour l'ouverture et la fermeture de la billetterie. Vous pouvez également définir une date limite 
                pour que vos athlètes puissent modifier leurs informations d'inscription.
              </p>
              <p className="help-text">
                Vous avez également la possibilité de programmer toute cette mise en place à l'avance.
              </p>
              <p className="help-text">
                La section des conditions générales est cruciale pour la bonne gestion de votre compétition. 
                Tous les athlètes qui s'inscrivent acceptent ces conditions avant de finaliser 
                leur inscription. Il est essentiel d'y détailler vos conditions d'annulation, les règles spécifiques 
                à votre événement, ainsi que toutes les informations importantes relatives à la compétition. N'oubliez 
                pas que ces conditions servent à protéger à la fois les participants et l'organisation, alors prenez le 
                temps de bien les formuler !
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[6].ref}>
              <p className="help-title-part">{anchorsParts[6].content}</p>
              <p className="help-text">
                Si vous souhaitez proposer des goodies à vos athlètes (tee-shirts, shorts, chaussettes), 
                vous pouvez facilement les intégrer lors de l'inscription.
              </p>
              <p className="help-text">
                Cochez les goodies que vous souhaitez proposer à vos athlètes. Les tailles disponibles s'afficheront ensuite, 
                et il vous suffira de sélectionner celles que vous offrirez, allant du XS au XL, pour homme, femme ou unisexe, 
                et une pointure minimal et maximal pour les chaussettes.
              </p>
              <p className="help-text mt-24">
                <strong className="mr-8">À noter : </strong>
                Vous avez également la possibilité de rendre ces goodies optionnels en ajoutant un prix supplémentaire.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[7].ref}>
              <p className="help-title-part">{anchorsParts[7].content}</p>
              <p className="help-text">
                Si vous avez besoin de volontaires pour vous assister dans la gestion de votre compétition, 
                cette section vous permet de tout configurer facilement. Cochez simplement sur <strong>Autoriser les inscriptions</strong>
              </p>
              <p className="help-text">
                Comme pour la billetterie, vous pourrez programmer l'ouverture et la clôture des inscriptions des volontaires. 
                Vous pourrez également définir la plage d'intervention et les rôles qu'ils pourront sélectionner pour aider 
                à la gestion de la compétition :
              </p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">Accueil des athlètes : </strong>
                    gestion de l'entrée de la salle, préparation et la distribution des packs pour les athlètes, supervision 
                    de la zone de warm-up etc.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">Juges : </strong>
                    pour être au plus près des athlètes et évaluer leurs performances sur le floor.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">Matériel : </strong>
                    Aider à la manutention et à la préparation du matériel sur le floor, dans la zone de warm-up, 
                    l'espace détente, et bien d'autres.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">Média : </strong>
                    âme de reporter ? Restez également au plus près des athlètes, capturez chaque moment.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">Saisie des scores : </strong>
                    intégrer l'équipe informatique pour saisir les scores des athlètes heat par heat et alimenter le leaderboard.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">Sécurité : </strong>
                    Participez à la gestion de la sécurité liée à la compétition, par exemple le contrôle des sacs, 
                    la prise en charge des blessés éventuels, la gestion des conflits etc.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56">
              <p className="help-text">
                Une fois que vous avez enregistré la dernière étape de la compétition, vous pourrez toujours la 
                <a target='_blank' className="link" href={`#`}>modifier.</a> 
              </p>
              <p className="help-text">
                De plus, de nouveaux onglets apparaîtront dans la barre latérale, vous offrant plus d'options pour ajuster 
                et personnaliser les détails de votre événement.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCreerAnnonce